import React from 'react';
import { Box } from '@mui/material';

const SectionContainer = ({ id, children, sx, ...props }) => (
  <Box
    id={id}
    component="section"
    sx={{
      maxWidth: 1240,
      mx: 'auto',
      px: { xs: 2.5, sm: 4, md: 6 },
      ...(id ? { scrollMarginTop: 'calc(var(--navbar-height, 96px) + 16px)' } : {}),
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);

export default SectionContainer;
